import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import axiosClient from '../../services/axiosClient';
import apiConfig from '../../services/apiconfig';

var bnrimg = require('./../../images/banner/1.jpg');

class ProjectClassic2 extends React.Component {
    state = {
        projects: [],
        services: [],
        loading: true
    };

    componentDidMount() {
        this.fetchData();
    }

    async fetchData() {
        try {
            const [projectsRes, servicesRes] = await Promise.all([
                axiosClient.get(apiConfig.PROJECTS.GET_ALL),
                axiosClient.get(apiConfig.SERVICES.GET_ALL)
            ]);

            this.setState({
                projects: projectsRes.data.data || [],
                services: servicesRes.data.data || [],
                loading: false
            }, () => {
                if (window.initMasonryAndPopup) {
                    setTimeout(() => {
                        window.initMasonryAndPopup();
                    }, 100);
                }
            });
        } catch (error) {
            console.error("Error fetching data for classic2", error);
            this.setState({ loading: false });
        }
    }

    render() {
        const { projects, services, loading } = this.state;

        return (
            <>
                <Header />
                <div className="page-content">
                    <Banner title="Creating quality urban lifestyles, building stronger communities." pagename="Project Classic View" bgimage={bnrimg} />

                    <div className="section-full p-tb80 bg-gray inner-page-padding">
                        <div className="container">
                            {loading ? (
                                <div className="text-center p-a50">Loading projects...</div>
                            ) : (
                                <>
                                    <div className="filter-wrap p-b30 text-center">
                                        <ul className="filter-navigation inline-navigation masonry-filter link-style text-uppercase">
                                            <li className="active"><NavLink to={"#"} data-filter="*" data-hover="All">All</NavLink></li>
                                            {services.map((item, index) => (
                                                <li key={index}>
                                                    <NavLink to={"#"} data-filter={`.cat-${item.slug}`} data-hover={item.name}>
                                                        {item.name}
                                                    </NavLink>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div className="portfolio-wrap mfp-gallery work-grid row clearfix">
                                        {projects.map((item, index) => {
                                            const filterClass = item.service ? `cat-${item.service.slug}` : '';
                                            return (
                                                <div key={item.id || index} className={`${filterClass} masonry-item col-md-6 col-sm-6 m-b30`}>
                                                    <div className="project-classic">
                                                        <div className="mt-box">
                                                            <div className="mt-thum-bx img-center-icon mt-img-overlay2">
                                                                <img
                                                                    src={item.featured_image}
                                                                    alt={item.title}
                                                                    style={{ height: '320px', width: '100%', objectFit: 'cover' }}
                                                                />
                                                                <div className="overlay-bx">
                                                                    <div className="overlay-icon">
                                                                        <NavLink to="/project-detail" state={{ projectSlug: item.slug }}>
                                                                            <i className="fa fa-external-link mt-icon-box-xs" />
                                                                        </NavLink>
                                                                        <a className="mfp-link" href={item.featured_image}>
                                                                            <i className="fa fa-arrows-alt mt-icon-box-xs" />
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="mt-info p-t20 text-center">
                                                                <h4 className="mt-title m-b10 m-t0">
                                                                    <NavLink to="/project-detail" state={{ projectSlug: item.slug }}>
                                                                        {item.title}
                                                                    </NavLink>
                                                                </h4>
                                                                {item.service && (
                                                                    <p className="m-b0 text-primary font-weight-600 font-12 text-uppercase">
                                                                        {item.service.name}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        );
    }
}

export default ProjectClassic2;
